import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { routes } from '@app/app.routes';
import { ConfigService } from '@app/config.service';

export async function appInitializer() {
    const configService = inject(ConfigService);
    const router = inject(Router);

    await configService.loadConfig();
    router.resetConfig(routes);
}
